// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3oFpP","col":"styles_col__39-gO","fulfillmentStatus":"styles_fulfillmentStatus__vxug6","emailCol":"styles_emailCol__3J6eI"};